import { ElMessage, ElNotification } from "element-plus";

export default {
    computed:{
        noticeCounter:function(){
            return this.$store.state.noticeCounter;
        }
    },
    watch:{
        noticeCounter:function(){
            let errorMessages = this.$store.state.errorMessages;
            let needConfirm = this.$store.state.noticeNeedConfirm;
            if(needConfirm){
                if(errorMessages.length > 0){
                    let error = errorMessages.map(x=>{
                        return "<p>"+x.ErrorMessage+"</p>";
                    });
                    error = '<p class="el-message-box__title">操作失败</p><div class="error-message-box__content">' + error + "</div>";
                    this.$confirm(
                        error, 
                        "",
                        {
                            confirmButtonText: '已读',
                            dangerouslyUseHTMLString: true,
                            customClass:"qweErrorMessageBox batchChangeFieldMessageBox",
                            showClose:false,
                            type: 'error',
                            showCancelButton:false,
                            closeOnClickModal:false
                        }
                    )
                }
            }
            else{
                (this.$store.state.errorMessages || []).forEach(element => {
                    setTimeout(function(){
                        ElMessage.error({
                            message: element.ErrorMessage,
                            duration:4000,
                            showClose:false,
                        });
                        console.log(element.ErrorResume + "-" + element.ErrorMessage);
                    },100)
                });
            }
            
            (this.$store.state.warnMessages || []).forEach(element => {
                setTimeout(function(){
                    ElNotification.warning({
                        title:"异常提醒",
                        message: element.ErrorMessage,
                        duration:0,
                        showClose:true
                    });
                    console.log(element.ErrorResume + "-" + element.ErrorMessage);
                },100)
            });

            this.$store.commit("ClearMessages");
        }
    }
}